<template>
  <router-view v-if="ready" />
</template>

<script>
import {
  isUnauthorizedError,
  redirectToGatewayLogin,
} from "@/utils/authFlow";

export default {
  data() {
    return {
      ready: false,
    };
  },
  created: function () {
    this.$store
      .dispatch("auth/checkToken")
      .then(() => {
        this.ready = true;
      })
      .catch((err) => {
        console.error("Token check failed:", err);
        if (isUnauthorizedError(err)) {
          redirectToGatewayLogin();
          return;
        }

        this.ready = true;
      });
  },
  methods: {
    // historyBack(event) {
    //   if(event.keyCode === 32) {
    //     this.$router.go(-1);
    //   }
    // }
  },
};
</script>
